import React from "react";
import { Button, Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Page from "../../Page";
import { FetchListadoEndosos } from "../../../redux/actions/aEndososBeneficiarios";

class TablaVehiculos extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            datosEndosos: {
                datosEndosos: []
            },
            listado: [],
            filtro: "",
            filtroValor: "",
            first: 0,
            rows: 10,
            totalRecords: 0,
            poliza: "",
            sucursal: "",
            ramo: "",
            paso: "listado"
        };
    }

    async componentDidMount() {
        const queryParams = new URLSearchParams(this.props.location.search);
        const poliza = queryParams.get("poliza");
        const sucursal = queryParams.get("sucursal");
        const ramo = queryParams.get("ramo");
        const body = {
            poliza,
            sucursal,
            ramo
        };
        await this.props.listadoEndososRamo({
            empCodigo: "AIGMETROPOLITANA",
            ...body
        })
        this.setState(body);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.datosEndosos !== prevProps.datosEndosos) {
            if (this.props.datosEndosos !== undefined &&
                this.props.datosEndosos.datosEndosos !== undefined &&
                Array.isArray(this.props.datosEndosos.datosEndosos)
            ) {
                this.setState({
                    listado: this.props.datosEndosos.datosEndosos,
                    totalRecords: this.props.datosEndosos.datosEndosos.length
                });
            }

        }

        if (this.state.listado) {

        }
    }

    renderDataRamo = () => {
        return (
            <Row style={{ marginLeft: 0 }}>
                <Col>
                    <Row>
                        <Col xl={1} lg={1} md={1}>
                            Póliza:
                        </Col>
                        <Col xl={11} lg={11} md={11}>
                            {this.state.poliza}
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={1} lg={1} md={1}>
                            Sucursal:
                        </Col>
                        <Col xl={11} lg={11} md={11}>
                            {this.state.sucursal}
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={1} lg={1} md={1}>
                            Ramo:
                        </Col>
                        <Col xl={11} lg={11} md={11}>
                            {this.state.ramo}
                        </Col>
                    </Row>
                </Col>
            </Row>
        )
    }

    renderMensajeCantidad = () => {
        const desde = this.state.totalRecords === 0 ? 0 : this.state.first + 1;
        const hasta = Math.min(this.state.first + this.state.rows, this.state.totalRecords);

        return (
            <Col>
                {`Mostrando ${desde} - ${hasta} de ${this.state.totalRecords} vehículos`}
            </Col>
        );
    }

    parseoRenderizadoEndoso = (rowData) => {
        const itemAsegurado = [
            {
                "label": "Placa:",
                "value": rowData.placa
            },
            {
                "label": "Modelo:",
                "value": rowData.modelo
            },
            {
                "label": "Chasis:",
                "value": rowData.chasis
            },
            {
                "label": "Año:",
                "value": rowData.anio
            },
            {
                "label": "Motor:",
                "value": rowData.motor
            },
            {
                "label": "Color:",
                "value": rowData.color
            },
            {
                "label": "Marca:",
                "value": rowData.marca
            },
            {
                "label": "Valor asegurado:",
                "value": rowData.sumaAseguradaLabel
            }
        ]
        return {
            data: rowData,
            dataItemAsegurado: itemAsegurado
        }
    }

    render() {
        const {
            listado,
            rows,
            first,
            totalRecords
        } = this.state;

        const {
            funciones
        } = this.props;
        return (
            <Page
                title={
                    "Items vehículos"
                }
            >
                {listado.length > 0 && (
                    <div>
                        <Row>
                            <Col>
                                {this.renderDataRamo()}
                                {this.renderMensajeCantidad()}
                                <Card body>
                                    <DataTable
                                        value={listado}
                                        responsive
                                        className="p-datatable-customers"
                                        rowHover
                                        paginator
                                        rowsPerPageOptions={[10, 25, 50]}
                                        emptyMessage="No se han encontrado resultados"
                                        resizableColumns
                                        rows={rows}
                                        first={first}
                                        totalRecords={totalRecords}
                                        onPage={(e) => {
                                            this.setState({
                                                first: e.first,
                                                rows: e.rows
                                            });
                                        }}
                                    >
                                        <Column
                                            className="counter"
                                            field="contador"
                                            header="#"
                                            style={{ width: "60px" }}
                                        />
                                        <Column
                                            field="placa"
                                            header="Placa"
                                            sortable
                                            style={{ width: "100px" }}
                                        />
                                        <Column
                                            header="Motor"
                                            field="motor"
                                            sortable
                                            style={{ width: "150px" }}
                                        />
                                        <Column
                                            header="Chasis"
                                            field="chasis"
                                            sortable
                                            style={{ width: "150px" }}
                                        />
                                        <Column
                                            header="Suma Asegurada"
                                            field="sumaAseguradaLabel"
                                            sortable
                                            style={{ width: "100px" }}
                                        />
                                        <Column
                                            header="Marca"
                                            field="marca"
                                            sortable
                                            style={{ width: "100px" }}
                                        />
                                        <Column
                                            header="Modelo"
                                            field="modelo"
                                            sortable
                                            style={{ width: "100px" }}
                                        />
                                        <Column
                                            header="Año"
                                            field="anio"
                                            sortable
                                            style={{ width: "100px" }}
                                        />
                                        <Column
                                            header="Color"
                                            field="color"
                                            sortable
                                            style={{ width: "150px" }}
                                        />
                                        <Column
                                            header="Código Item"
                                            field="cod_item"
                                            sortable
                                            style={{ width: "150px" }}
                                        />
                                        <Column
                                            header=""
                                            body={(rowData) => {
                                                return (
                                                    <Col style={{ textAlign: "center", margin: "1.5px" }}>
                                                        <Button className={"btn btn-primary"} style={{ margin: "auto" }} onClick={() => {
                                                            funciones.ingresarEndoso(
                                                                this.parseoRenderizadoEndoso(rowData)
                                                            )
                                                        }
                                                        }>
                                                            <p style={{ margin: 0 }}>Endosos</p>
                                                        </Button>
                                                    </Col>
                                                );
                                            }}
                                            style={{ width: "150px" }}
                                        />
                                    </DataTable>
                                </Card>
                            </Col>
                        </Row>
                    </div>

                )}

                {listado.length === 0 && (
                    <Row>
                        <Col
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            className="detalle-cotizacion-box"
                        >
                            <Card className="mb-3">
                                <CardHeader style={{ borderBottom: "none" }}></CardHeader>
                                <CardBody>
                                    <h2 style={{ color: "#001871", textAlign: "center" }}>
                                        {" "}
                                        NO SE HA ENCONTRADO REGISTROS DE VEHICULOS ASOCIADOS
                                    </h2>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                )}
            </Page>
        )
    }
}

const mapStateToProps = (state) => ({
    datosEndosos: state.dataEndosos
});

const mapDispatchToProps = (dispatch) => {
    return {
        listadoEndososRamo: (body) => dispatch(FetchListadoEndosos(body))
    };
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(TablaVehiculos)
);